module.exports = __webpack_public_path__ + "img/LoadingTwo.319defa0.gif";